import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function CalendlyCustomButton() {
  const { t } = useTranslation();
  useEffect(() => {
    // Load Calendly script dynamically
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/domm-digital-web/30min",
      });
    }
  };

  return (
    <>
      {/* Calendly widget CSS */}
      <link
        href="https://assets.calendly.com/assets/external/widget.css"
        rel="stylesheet"
      />

      {/* Your custom button */}
      <button onClick={openCalendly} className="main-btn">
        {t("hero.brief-btn")}
      </button>
    </>
  );
}
